const Form012TC = {
    stepName: {
        basicInformation: "基本資料",
        activitiesInformation: "計劃的各項活動資料",
        effectiveness: "計劃成效與意見",
        projectEvaluation: "計劃評估",
        incomeExpenditure: "活動收支表",
        cost: "計劃行政費及計劃統籌費開支表",
        confirmation: "確認",
    },
    title: {
        title1: "學年校本課後學習及支援計劃（{{schoolYear}}學年）",
        title2: "區本計劃終期報告 （{{deadline}}）",
        title3: "(須於{{sumbitDeadline}}把正本送抵教育局學生特別支援組)",
    },
    important: {
        title: "個人資料收集聲明",
        note1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰ ",
        note2: "(a) 辦理與聘用有關的事宜；",
        note3: "(b) 處理發放薪金津貼，以及計算公積金的供款和贈款；",
        note4: "(c) 進行核數工作；",
        note5: "(d) 進行研究及統計資料，以便規劃教育服務；",
        note6: "(e) 處理有關教育專業人員發展的事宜；",
        note7: "(f) 執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",
        note8: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。 ",
        note9: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。 ",
        note10: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。 ",
        note11: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    },
    notes: {
        tips1: "1. 電子表格所載的資料均以教育局網頁上之表格為準",
        tipsUrl:
            "https://www.edb.gov.hk/tc/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        tips2: "2. 校本課後學習及支援計劃區本計劃進度報告（截至該學年的12月31日為止）（本表經填妥及簽署後須於該學年的1月31日或以前提交教育局學生特別支援組）",
        remarks: {
            tips1: "合資格學生：領取綜合社會保障援助（綜援）、學生資助計劃全額津貼(全額津貼)或使用酌情名額權的清貧學生（只適用於由協作學校甄選的清貧學生）",
            tips2: "非合資格學生：自費參加活動的學生，參加學生<u>必須繳付全費</u>，全費是指每名參加學生（包括合資格及非合資格學生）在活動的<span><b>實際</b>總開支</span>所佔的成本（例如：活動實際總開支為1,000元，有6名合資格學生及4名非合資格學生參加，每一名學生的成本便是100元；每一名非合資格學生因此需繳付100元）",
            tips3: "活動完成情況：註明活動為<b> (a) 已完成 或 (b) 取消。</b>",
            tips4: "活動資助額：從核准計劃分配給這項活動的款項（<u>只資助合資格學生</u>，非合資格學生須全費繳付活動實際總開支的全費）。",
            tips5: "其他收入：例如<u>非合資格學生</u>所繳交的參加費用、捐款及贊助等。",
            tips6: "開支：舉辦活動的實際開支（包括機構補貼活動的開支）。",
            tips7: `由於活動取消需扣減獲批行政費用的百分比 (扣減百分比) 須與 <u>獲批</u>的行政費所佔的百分比相同 (見獲批申請表 <span><b>J部</b></span><b> )</b>。 有關計算如下：\n<div style="display:flex;align-items:center;">扣減百分比 =  <div style="display:inline-block;"><div style="display:flex;flex-direction: column;"><span>獲批行政費用（乙）</span> <hr /> <span>獲批計劃活動的開支（甲）</span></div></div> × 100%  <span>(四捨五入至小數點後兩個位)</span></div>\n因此，須扣減獲批行政費用的金額計算如下：該項活動資助額 × 扣減百分比`,
            tips8: `由於活動取消需扣減獲批計劃統籌費用的百分比 (扣減百分比) 須與 <u>獲批</u>的計劃統籌費所佔的百分比相同 (見獲批申請表 <span><b>J部</b></span><b> )</b>。 有關計算如下：\n<div><span style="display: inline-block;transform: translateY(11px);">扣減百分比 =</span>  <div style="display:inline-block;"><div style="display:flex;flex-direction: column;"><span>獲批計劃統籌費用（丙）</span> <hr /> <span>獲批計劃活動的開支（甲）</span></div></div> <span style="display: inline-block;transform: translateY(11px);">× 100% (四捨五入至小數點後兩個位)</span></div>\n<div>因此，須扣減獲批計劃統籌費用的金額計算如下：該項活動資助額(A1) × 扣減百分比</div>`,
            tips9: "各類別的學生<br>- NCS（非華語學生）<br>- SEN（有特殊學習需要的學生）<br>- NAC（新來港學童）",
            tips10: "若活動開放予區內合資格學生參加，機構應<u><b>優先取錄</b></u>合資格的Od\n- Od（來自(I)項以外的官立、資助、按位津貼學校、直接資助計劃學校及私立學校的學生）\n- Cs（來自(I)項所列協作學校的學生）",
        },
    },
    label: {
        basicInformation: "基本資料",
        organisationName: "機構名稱",
        projectTitle: "計劃名稱",
        applicationRefNO: "計劃編號",
        projectCoordinator: "計劃統籌員姓名",
        contactPerson: "聯絡人姓名",
        contactTelNo: "聯絡電話",
        stepOption: {
            ActivitiesWithSchoolPart1: "與學校協作的活動",
            ActivitiesOpenCommunityPart1: "服務整個地區的活動",
        },
        activitiesSchoolTips: "請填寫所有核准活動的資料",
        selectContent: "選擇要填寫的內容",
        activitiesInformation: "甲. 計劃的各項活動資料",
        activitiesSchoolIa: "(I) (a) 與學校協作的活動（列明所有獲批活動）",
        activitiesStudentsNo: "獲批核活動的合資格學生人數",
        activitiesStudentsNoBefore: "獲批核活動的合資格學生",
        activitiesStudentsNoAfter: "人數",
        activityName: "活動名稱",
        schoolName: "協作學校名稱",
        actualNo: "實際參與學生人數",
        remark: "備註",
        remarkEg: "（如註明活動日期，例：逢星期一、三及五下午4:00-5:30）",
        eligibleStudents: "合資格學生",
        nonEligiblestudents: "非合資格學生",
        secdNoTitle: "中學人數",
        priNoTitle: "小學人數",
        specNoTitle: "特殊學校人數",
        average: "平均出席率（%）",
        isSchedule: "活動完成情況",
        financialReport: "財務報告",
        flagOption: {
            0: "否",
            1: "是",
        },
        a1: "活動資助額 (HK$) (A1)",
        b1: "其他收入 (HK$) (B1)",
        c1: "機構補貼 (HK$) (C1)",
        d1: "開支 (HK$) (D1)",
        a2: "活動資助額 (HK$) (A2)",
        b2: "其他收入 (HK$) (B2)",
        c2: "機構補貼 (HK$) (C2)",
        d2: "開支 (HK$) (D2)",
        totalTitle: "總計",
        activitiesTotalNo: "活動項目總數",
        completedActivitiesTotalNo: "已完成活動項目總數",
        priTotalNo: "小學總人數",
        secdTotalNo: "中學總人數",
        specTotalNo: "特殊學校總人數",
        manTimesTotal: "人次（上列人數的總和）",
        a1Total: "總計 (HK$) (A1)",
        b1Total: "總計 (HK$) (B1)",
        c1Total: "總計 (HK$) (C1)",
        d1Total: "總計 (HK$) (D1)",
        a2Total: "總計 (HK$) (A2)",
        b2Total: "總計 (HK$) (B2)",
        c2Total: "總計 (HK$) (C2)",
        d2Total: "總計 (HK$) (D2)",
        activitiesSchoolIb: `(I) (b) 協作學校的參加學生資料（{{deadline}}）`,
        activitiesSchoolIbi: "（i）領取綜援的學生",
        activitiesSchoolIbii: "（ii）領取全額津貼的學生",
        activitiesSchoolIbiii:
            "（iii）學校使用酌情權的清貧學生（不超過25%）（只適用於與學校協作，並由校方提供）",
        activitiesSchoolIbiv: "（iv）受惠的合資格學生（i）+（ii）+（iii）共＝",
        activitiesSchoolIbivBefore: "（iv）受惠的合資格學生",
        activitiesSchoolIbivAfter: "（i）+（ii）+（iii）共＝",
        activitiesSchoolIbv: "（v）非合資格學生（必須繳付全費）",
        activitiesSchoolIbvBefore: "（v）非合資格學生 ",
        activitiesSchoolIbvAfter: "（必須繳付全費）",
        activitiesSchoolIbTotal: "總學生人數:（iv）+（v）＝",
        schoolTypeOption: {
            primarySchool: "小學",
            secondarySchool: "中學",
            specialSchool: "特殊學校",
        },
        primarySchool: "小學",
        studentsNo: "人數",
        studentsTitleBefore: "如有下列類別",
        studentsTitleAfter: "，請填寫",
        applicableType: "如果適用",
        NCS: "非華語學生",
        SEN: "有特殊學習需要的學生",
        NAC: "新來港學童",
        secondarySchool: "中學",
        specialSchool: "特殊學校",
        total: "總計薪水",
        ngoChopFile: "印鑑",
        activitiesCommunityIIA:
            "(II) (a) 服務整個地區的活動（列明所有獲批活動）",
        actualSituationOption: {
            "(a)": "(a) 已完成",
            "(b)": "(b) 取消",
        },
        actualSituation: "活動完成情況",
        approvedStudentsNo: "活動獲批核的合資格學生人數",
        Od: "Od",
        Pv: "Pv",
        Cs: "Cs",
        odTips: "來自(I)項以外的官立、資助、按位津貼學校、直接資助計劃學校及私立學校的學生",
        pvTips: "來自私立學校的學生",
        csTips: "來自(I)項所列協作學校的學生",
        primaryOd: "Od（小學）",
        primaryPv: "Pv（小學）",
        primaryCs: "Cs（小學）",
        secondaryOd: "Od（中學）",
        secondaryPv: "Pv（中學）",
        secondaryCs: "Cs（中學）",
        specialOd: "Od（特殊學校）",
        specialPv: "Pv（特殊學校）",
        specialCs: "Cs（特殊學校）",
        averageRate: "平均出席率（%）",
        odTotal: "Od總計",
        pvTotal: "Pv總計",
        csTotal: "Cs總計",
        primaryOdTotal: "Od總計（小學）",
        primaryPvTotal: "Pv總計（小學）",
        primaryCsTotal: "Cs總計（小學）",
        secondaryOdTotal: "Od總計（中學）",
        secondaryPvTotal: "Pv總計（中學）",
        secondaryCsTotal: "Cs總計（中學）",
        specialOdTotal: "Od總計（特殊學校）",
        specialPvTotal: "Pv總計（特殊學校）",
        specialCsTotal: "Cs總計（特殊學校）",
        approvedStudentsNoTotal: "總人次（上列人數的總和）",
        activitiesCommunityIIB: `(II) (b) 參加地區活動的學生資料（{{deadline}}）`,
        activitiesCommunityIIBvi: "(vi) 領取綜援的學生",
        activitiesCommunityIIBvii: "(vii) 領取全額津貼的學生",
        activitiesCommunityIIBviii: "(viii) 受惠的合資格學生: (vi) + (vii) ＝",
        countByHead: "人數",
        primaryHeads: "小學",
        secondaryHeads: "中學",
        specialHeads: "特殊學校",
        totalHeads: "總計",
        typeStudentsNo: "如有下列類別",
        typeStudentsNoBefore: "如有下列類別",
        typeStudentsNoAfter: "，請填寫",
        ncs: "NCS（非華語學生）",
        sen: "SEN（有特殊學習需要的學生）",
        nac: "NAC（新來港學童）",
        totalViii: "總計（人數）：（vi）總計+（vii）總計＝",
        totalNcs: "總計（NCS）：（vi）NCS+（vii）NCS＝",
        totalSen: "總計（SEN）：（vi）SEN+（vii）SEN＝",
        totalNac: "總計（NAC）：（vi）NAC+（vii）NAC＝",
        activitiesCommunityIIBix: "（ix）非合資格學生（必須繳付全費）：",
        activitiesCommunityIIBixBefore: "(ix) 非合資格學生",
        activitiesCommunityIIBixAfter: "（必須繳付全費）：",
        activitiesCommunityIIBTotal: "總學生人數（viii）+（ix）＝",
        activitiesCommunityIIBx: "總學生人數（viii）+（ix）＝",
        totalX: "總計（人數）：（viii）總計+（ix）總計＝",
        totalXNcs: "總計（NCS）：（viii）NCS+（ix）NCS＝",
        totalXSen: "總計（SEN）：（viii）SEN+（ix）SEN＝",
        totalXNac: "總計（NAC）：（viii）NAC+（ix）NAC＝",
        financialSummaryIII: `(III) 整個計劃財務資料總結（{{deadline}}）`,
        summaryE: "(E) 行政費開支",
        summaryF: "(F) 計劃統籌開支",
        summaryG: "(G) 機構補貼行政費及計劃統籌費開支",
        summaryH: "(H) 計劃總開支 = (D1) + (D2) + (E) + (F)",
        summaryI: "(I) 獲批資助總額 (即按照申請表 J 部第 5 項填寫)",
        summaryJ: "(J) 已收取資助總額",
        summaryK: "(K) 所賺取利息 (如有)",
        summaryL:
            "(L) 計劃總收入 = (B1) + (B2) + (C1) + (C2) + (G) + (J) + (K)",
        summaryBalance: "結餘 = (L) – (H)",
        summaryTips:
            "<i>請按照申請表J部第5項填寫，即本報告截止日期前批核給貴機構執行此計劃的總撥款</i>",
        effectiveness: "乙.計劃成效",
        effectivenessTips:
            "整體來說，你認為已完成／正進行的活動對受惠合資格學生有何得益？",
        learningEffectiveness: "學習成效",
        effectivenessOption: {
            1: "明顯改善",
            2: "適度改善",
            3: "輕微改善",
            4: "沒有改變",
            5: "下降",
            6: "不適用",
        },
        learningMotivation: "a）學生的學習動機",
        studySkills: "b）學生的學習技巧",
        academicAchievement: "c）學生的學業成績",
        outsideExperience: "d）學生於課堂外的學習經歷",
        overallEffectivenes: "e）你對學生學習成效的整體觀感",
        development: "個人及社交發展",
        selfEsteem: "f）學生的自尊心",
        selfManagement: "g）學生的自我照顧能力",
        socialSkills: "h）學生的社交技巧",
        interpersonalSkills: "i）學生的人際技巧",
        cooperativenessSkill: "j）學生與他人合作能力",
        attitudesToward: "k）學生對求學的態度",
        outlookOnLife: "l）學生的人生觀",
        overallView: "m）你對學生個人及社交發展的整體觀感",
        communityInvolvement: "社區參與",
        participation: "n）學生參與課外及義工活動的情況",
        belongingSense: "o）學生的歸屬感",
        understanding: "p）學生對社區的了解",
        overallView2: "q）你對學生參與社區活動的整體觀感",
        comments: "丙.對已完成計劃的意見",
        difficulties:
            "在推行計劃時，你有否遇到以下問題／困難?\n（請在適當的方格內填上「√」號，可選多於一項。）",
        difficultiesOption: {
            manpower: "沒有足夠人力推行計劃",
            eligibleStudents:
                "協作學校未能提供足夠的合資格學生（即領取綜援及全額津貼的學生）參加活動",
            eligibleUnwilling: "合資格學生不願意參加計劃",
            collaborating: "協作學校未能提供適當的支援",
            unableEmploy: "難以聘請合資格導師推行活動",
            funds: "執行教育局在處理撥款方面的要求感到困難",
            reportComplicated: "提交報告的要求繁複及費時",
            other: "其他",
        },
        specify: "請說明",
        specifyReason: "請說明其原因",
        otherMsg: "意見",
        suggestions:
            "如你對區本計劃有其他意見（例如：協作模式、活動類別等），請在下方說明",
        incomeExpenditure: `戊(一) 活動收支表（{{deadline}}）`,
        projectInformation: "項目基本情況",
        actualEligibleNo: "實際合資格學生參加人數",
        actualNoneligibleNo: "實際非合資格學生參加人數",
        incomeItems: "收入項目",
        grantAmount: "此項活動獲批撥款金額",
        nonEligibleFees: "非合資格學生收費",
        othersIncome: "其他收入",
        otherSpecify: "請註明",
        othersExpenditure: "其他開支",
        totalA: "總收入（A）",
        subsidyB: "機構補貼（B）",
        expenditureItems: "開支項目",
        totalGroups: "共開（組）",
        sessions: "每組（節）",
        hr: "小時",
        tutorFee: "導師開支",
        statement: "聲明",
        halfDay: "半日",
        fullDay: "全日",
        tutorsNo: "導師人數",
        hourlySalary: "時薪",
        otherStaffNo: "其他人數",
        socialWorkersNo: "社工人數",
        material: "活動物資",
        campAdmissionFee: "營費／入場費",
        studentsMeal: "學生膳食",
        transportationFee: "活動交通費",
        volunteersNo: "義工人數",
        volunteersAllowance: "義工津貼",
        totalC: "總開支（C）",
        balance: "結餘（A+B-C）",
        time: "每組（次）",
        fullOrHalf: "半日或是全日",
        fullOrHalfOption: {
            half: "半日",
            full: "全日",
        },
        activitiesSchool: "(I) 與學校協作的活動",
        approvedProject: "核準計劃資料",
        activitiesTotal1: "活動項目總數（a1）",
        activitiesTotal2: "活動項目總數（a2）",
        schoolsTotal: "學校總數",
        completedTotal: "已完成總數",
        inProgressTotal: "進行中總數",
        notCommencedTotal: "未開展總數",
        cancelledTotal: "擬取消總數",
        adjustmentTotal: "需修訂總數",
        a1a2Total: "合計：（I）+（II）的核準活動項目總數＝（a1）+（a2）",
        headName:
            "非政府機構／非政府機構的部門／非政府機構的附屬機構負責人／計劃統籌員",
        name: "姓名",
        post: "職位",
        AdministExpenses: "行政開支項目",
        transportationFees: "工作人員交通費",
        photoCopy: "影印費",
        stationery: "文儀用品",
        postage: "郵費",
        administrationCostA: "獲批行政費用總額（A）",
        administrationTotalB: "扣減後獲批行政費用總額 (B) (B = A - E1 - E2)",
        administrationCostC: "行政費用結餘 (C) = (B + G - E)",
        administrationCostE: "行政費總開支 (E)",
        administrationCostF: "因活動取消所扣減行政費用 (E1+E2)",
        administrationCostG: "機構補貼行政費用 (如有) (G)",
        projectCoordinationCostA: "獲批計劃統籌費用總額 (A)",
        projectCoordinationTotalB:
            "扣減後獲批計劃統籌費用總額 (B) (B = A - F1 - F2)",
        projectCoordinationCostC: "計劃統籌費用結餘 (C) = (B + G - F)",
        projectCoordinationCostE: "計劃統籌費總開支 (F)",
        projectCoordinationCostF: "因活動取消所扣減計劃統籌費用 (F1 + F2)",
        projectCoordinationCostG: "機構補貼計劃統籌費用 (如有) (G)",
        statementAdministrationCost: `計劃行政費用開支表（{{deadline}}）`,
        statementProjectCoordinationCost: `計劃統籌費用開支表（{{deadline}}）`,
        ngoOption: {
            ngo: "非政府機構",
            department: "非政府機構的部門",
            subsidiaryOrganisation: "非政府機構的附屬機構負責人",
            project: "計劃統籌員",
        },
        checkedFlag:
            "本人已審閱本表格內填報的資料，並核實所有支出單據真確無誤。",
        Notes: "註意",
        statementCheck: "本人已閱讀、明白及同意上述條款及細則",
        projectCoordinationCostTitle: "需扣減行政費用/計劃統籌費用 ($)",
        projectCoordinationCostTitleExplanation: "(只適用於已取消活動)",
        administrationCost: "行政費用",
        projectCoordinationCost: "計劃統籌費用",
        administrationCostTotal: "總計行政費用",
        projectCoordinationCostTotal: "總計計劃統籌費用",
        projectRefNo: "計劃編號",
        venue: "活動地點",
        nonEligibleStudents: "非合資格學生人數",
        teachingAssistant: "教學助理人數(如有)",
        cancellationActivityReason: "請說明取消活動原因（如適用）",
        completedByCollaboratingSchool: "此部分由協作學校填寫",
        confirmDataAccurate: "本人已核實上方格內的資料無誤。",
        collaboratingSchoolName: "姓名",
        collaboratingSchoolPost: "職位",
        collaboratingSchoolDate: "日期",
        collaboratingSchoolSign: "簽署",
        completedActivityDetails: "已完成活動情況",
        schoolPostOption: {
            principal: "校長",
            supervisor: "負責老師",
        },
        activeTableCheckMsg:
            "本人已審閱本表格內填報的資料，確認上述獲批核活動的完成情況，並核實所有支出單據真確無誤。",
        nGOHeadOption: {
            nGOHead: "非政府機構",
            department: "非政府機構的部門",
            subsidiaryOrganisation: "非政府機構的附屬機構負責人",
            projectCoordinator: "計劃統籌員",
        },
        deductedPercentage: "扣減百分比",
        costTableTitle: "校本課後學習及支援計劃 ({{schoolYear}}) ",
        projectEvaluationAttachment:
            "貴機構曾否就舉辦的區本計劃活動向協作學校、參與學生、家長、教師及職員進行任何調查？如有，請夾附調查結果。",
        otherEvaluation:
            "若貴機構有對推行的區本計劃作成效評估，如計劃是否達到預期目標及學校與家長對計劃的反應等，請表述如下",
        applicantInformation: "申請人信息",
        ngoTypeLabel: "非政府機構／非政府機構的部門／非政府機構的附屬機構",
        ngoType: "非政府機構／非政府機構的部門／非政府機構的附屬機構名稱",
        ngoName: "{{ngoType}}名稱",
        ngoHeadType:
            "非政府機構／非政府機構的部門／非政府機構的附屬機構負責人／計劃統籌員",
        ngoHeadTypeName: "{{ngoType}}負責人／計劃統籌員",
        ngoHeadName: "非政府機構計劃統籌員姓名",
        ngoHeadPost: "非政府機構計劃統籌員職位",
        ngoChargeName: "非政府機構計劃負責人姓名",
        ngoChargePost: "非政府機構計劃負責人職位",
        ngoHead: "{{ngoType}}負責人",
        incomeExpenditureToBeCompleted: "活動收支表（此部分由協作學校填寫）",
        uploadFile: "上載表格",
        formATitle:
            "附件上傳部分（此部分由非政府機構上載已簽署的完整表格及其他補充資料）",
        formBTitle:
            "附件上傳部分（此部分由非政府機構上載已簽署的完整表格及其他補充資料）",
        cancelledActivityTitle: "(已取消)",
    },
    comma: "，",
    semicolon: "；",
    select: {
        ngoOption: {
            ngo: "非政府機構",
            department: "非政府機構的部門",
            subsidiaryOrganisation: "非政府機構的附屬機構",
        },
        ngoHeadOption: {
            ngoHead: "負責人",
            projectCoordinator: "計劃統籌員",
        },
    },
    errorMsg: {
        "E-0000": "提名人數銜是必需的[E-0000]",
        "E-0001": "提名人姓名是必需的[E-0001]",
        "E-0100": "獎勵提名是必需的[E-0100]",
        "E-0101":
            "包含英文字符、空格、點、逗號、連字符和單引號。數字是不允許的。",
        "E-0102": "僅限中文",
        "E-0103": "如果中文商業代碼中的中文名稱不為空，則不得為空。",
        "E-0104": "僅字母表",
        "E-0105": "僅字母數字",
        "E-0106":
            "包含數字字符和特殊字符，它們是空格（）、加號（+）、哈希（#）、括號（（））和連字符（-）。",
        "E-0107": "僅數字",
        "E-0108":
            "允許小數點後一位。包含數字字符和特殊字符，這些字符是空格（）、加號（+）、哈希（#）、括號（()）、連字符（-）和斜杠（／）。",
        "E-0109": "與20XX\\XX格式不匹配",
        "E-0110": "該值在出生日期之後.",
        "E-0111": "必須至少有一個文件",
        "E-0112": "不能超過2個文件",
        "E-0113": "不符合香港身份證規則",
        "E-0114": "最小長度8",
        "E-0115": "最大長度為20",
        "E-0116":
            "最小長度、最大長度（默認值100）、字符類型（僅字母／字母數字／僅中文）、模式包含數字字符和特殊字符，它們是空格（）、加號（+）、井號（#）、括號（()）和連字符（-）",
        "E-0117":
            "最小長度、最大長度（默認值100）、字符類型（僅字母／字母數字／僅中文）、模式",
        "E-0118": "必須是正整數",
        "E-0119": "必須是浮點數，最大值：100",
        "E-0120": "前2項中的一項是必需的",
        "E-0121": "整數部分最多6位，最多2位小數",
        "E-0122": "需要兩個部分中的一個",
        "E-0123": "{{fildName}}不可重複",
        "E-0124": "此字段必須至少包含{{number}}個字符",
        "E-0125": "此必須至少包含1項",
        "E-0126": "前三項必須填寫一項",
        "E-0127": "此項必須小於或等於{{fildName}}",
        "E-0128": "請不要選擇重複的學校類型",
    },
    statement: {
        tips1: "1. 電子表格所載的資料均以教育局網頁上之表格為準",
        tipsUrl:
            "https://www.edb.gov.hk/tc/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        tips2: "2. 校本課後學習及支援計劃區本計劃終期報告（截至該學年的7月31日為止） （本表經填妥及簽署後須於該年的9月30日或以前提交教育局學生特別支援組）",
    },
};
export default Form012TC;
